import { jsx as t, Fragment as m } from "react/jsx-runtime";
import { ComboboxPopover as r, ComboboxList as p, ComboboxOption as s } from "@vp/swan";
import g from "./help-center-articles-search23.js";
/* empty css                              */
const d = ({ queryResults: o }) => /* @__PURE__ */ t(r, { className: "query-suggestions-combobox-popover", placement: "bottom", children: /* @__PURE__ */ t(p, { "data-testid": "query-suggestions-list", children: o && o.items.length > 0 ? o.items.map((e) => b(e, o.filterText)) : null }) });
function b(o, e) {
  const n = o.items.map((i) => /* @__PURE__ */ t(s, { padding: 0, textValue: i.title, children: /* @__PURE__ */ t(g, { searchItem: i, searchTerm: e }) }, i.objectID));
  return /* @__PURE__ */ t(m, { children: n });
}
export {
  d as HCSComboboxPopover
};
//# sourceMappingURL=help-center-articles-search10.js.map
